import CustomHelmet from "../../components/helmet/CustomHelmet.tsx";
import LegalBanner from "../../components/privacy-policy-page-components/legal-banner/LegalBanner.tsx";
import bannerImage from "/assets/images/why-opay-page-images/icon-about-feature-13.svg";
import LegalPageSections
    from "../../components/privacy-policy-page-components/privacy-policy-sections/LegalPageSections.tsx";
import {FraudGuidelinesSectionsConfig} from "../../configs/legal-pages/fraudGuidelinesSections.ts";

const FraudGuidelinesPage = () => {
    return (
        <>
            <CustomHelmet title={'titles.fraud_guidelines'} />
            <LegalBanner heading={'fraud_guidelines'} image={bannerImage} />
            <LegalPageSections config={FraudGuidelinesSectionsConfig} />
        </>
    )
}

export default FraudGuidelinesPage;
